import React, { useEffect, useState } from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pagos.academiaholisticaargentina.com/cart/48444837920985:1';
const CHECKOUT_PRO = 'https://pagos.academiaholisticaargentina.com/cart/48444840083673:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [selected, setSelected] = useState<'pro' | 'base'>('pro');
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const checkoutUrl = selected === 'pro' ? CHECKOUT_PRO : CHECKOUT_BASE;
  const ctaLabel = selected === 'pro' ? '→ QUIERO EL MEGAPACK + KIT PROFESIONAL' : '→ QUIERO MI MEGAPACK';
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-333">
      <div className="container mx-auto max-w-4xl" data-id="element-334">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-335">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-336">
            ⏰ PRECIO DE RELANZAMIENTO — CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-337">
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-338">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-339">hs</span>
            <span className="text-[#eab308] text-2xl font-bold animate-pulse" data-id="element-340">
              :
            </span>
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-341">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-342">min</span>
            <span className="text-[#eab308] text-2xl font-bold animate-pulse" data-id="element-343">
              :
            </span>
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-344">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-345">seg</span>
          </div>

          <p className="text-red-500 font-bold text-lg mb-6" data-id="element-346">
            ⚠️ Después sube. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-[#111111] p-4 rounded-xl border border-white/10" data-id="element-347">
            <div className="flex justify-between text-xs font-bold mb-2" data-id="element-348">
              <span className="text-white" data-id="element-349">
                🔴 Cupos al precio de relanzamiento
              </span>
              <span className="text-[#eab308]" data-id="element-350">68%</span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2.5" data-id="element-351">
              <div className="bg-gradient-to-r from-red-600 to-[#eab308] h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-352"></div>
            </div>
            <p className="text-gray-400 text-[10px] mt-2 text-center" data-id="element-353">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-354">
          <div className="text-center mb-6" data-id="element-355">
            <h3 className="text-2xl font-bold text-white" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-356">
              ELEGÍ TU MEGAPACK
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 items-stretch" data-id="element-357">
            {/* Pro Card */}
            <div onClick={() => setSelected('pro')} className={`relative bg-gradient-to-b from-[#111111] to-[#0a0a0a] rounded-xl p-3.5 sm:p-4 flex flex-col z-10 cursor-pointer transition-all duration-300 ${selected === 'pro' ? 'border-2 border-[#eab308] shadow-[0_0_40px_rgba(234,179,8,0.2)]' : 'border-2 border-white/10 opacity-70 hover:opacity-90'}`} data-id="element-358">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'pro' ? 'border-[#eab308] bg-[#eab308]' : 'border-white/30 bg-transparent'}`} data-id="element-359">
                {selected === 'pro' && <CheckIcon className="w-3 h-3 text-[#0f0f1a]" strokeWidth={3} data-id="element-360" />}
              </div>

              <div className="mb-2" data-id="element-361">
                <span className="bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[9px] font-bold px-2.5 py-0.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-362">
                  ⭐ RECOMENDADO
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-white mb-1" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-363">
                🏆 MEGAPACK + KIT PROFESIONAL ⭐
              </h3>
              <p className="text-[#eab308] font-bold text-xs mb-2" data-id="element-364">
                6 Tomos + 6 Bonos + Formación de Alumnos
              </p>

              <p className="text-gray-300 text-[10px] leading-snug mb-3" data-id="element-365">
                <span className="text-white font-bold" data-id="element-366">Ideal para:</span>{' '}
                Practicar, enseñar y armar tu escuela de Reiki
              </p>

              <div className="mt-auto" data-id="element-367">
                <p className="text-gray-500 text-xs line-through" data-id="element-368">$89.000</p>
                <p className="text-3xl sm:text-4xl font-extrabold text-[#eab308] leading-none" style={{
                textShadow: '0 0 30px rgba(234,179,8,0.4)'
              }} data-id="element-369">
                  $27.990{' '}
                  <span className="text-base font-bold text-white" data-id="element-370">ARS</span>
                </p>
              </div>
            </div>

            {/* Base Card */}
            <div onClick={() => setSelected('base')} className={`relative bg-[#111111] rounded-xl p-3.5 sm:p-4 flex flex-col cursor-pointer transition-all duration-300 ${selected === 'base' ? 'border-2 border-[#eab308] shadow-[0_0_40px_rgba(234,179,8,0.2)]' : 'border-2 border-white/10 opacity-70 hover:opacity-90'}`} data-id="element-371">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'base' ? 'border-[#eab308] bg-[#eab308]' : 'border-white/30 bg-transparent'}`} data-id="element-372">
                {selected === 'base' && <CheckIcon className="w-3 h-3 text-[#0f0f1a]" strokeWidth={3} data-id="element-373" />}
              </div>

              <div className="mb-2 pt-3" data-id="element-374"></div>

              <h3 className="text-base sm:text-lg font-bold text-white mb-1" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-375">
                📘 MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-white font-bold text-xs mb-2" data-id="element-376">
                6 Tomos + 6 Bonos
              </p>

              <p className="text-gray-300 text-[10px] leading-snug mb-3" data-id="element-377">
                <span className="text-white font-bold" data-id="element-378">Ideal para:</span>{' '}
                Formarse, practicar y certificarse en Reiki I, II y Maestría
              </p>

              <div className="mt-auto" data-id="element-379">
                <p className="text-gray-500 text-xs line-through" data-id="element-380">$69.000</p>
                <p className="text-3xl sm:text-4xl font-extrabold text-white leading-none" style={{
                textShadow: '0 0 30px rgba(255,255,255,0.15)'
              }} data-id="element-381">
                  $19.990{' '}
                  <span className="text-base font-bold text-gray-400" data-id="element-382">ARS</span>
                </p>
              </div>
            </div>
          </div>

          {/* Single CTA Button — sticky on mobile */}
          <div className="mt-6 max-w-xl mx-auto sticky bottom-4 z-30" data-id="element-383">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full block py-3.5 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-xs sm:text-base tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_0_30px_rgba(234,179,8,0.5)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-384">
              {ctaLabel}
            </a>
          </div>
        </div>
      </div>
    </section>;
}